module.exports = new __parcel__URL__("services_6.cb0781f9.jpg").toString();